import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';

import { IssueSupplier, IssueUpdateDataSupplier, IssuesFilterSupplier, QuproList, QuproServiceError, SupplierCommentUpdateDataBase,
  SupplierAgreementUploaded, QuproServiceErrorType, BaseUser, IssueUpdateResponse } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, IssuePopulateService, UiService, MessagesService } from '../../../services/api.services';
import { IssueFront, IssueFrontSelection, ISignedData } from '../../../models/api.models';

import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';
import { AddComentarioModalComponent } from '../../shared/add-comentario-modal/add-comentario-modal.component';
import { IssueImageComponent } from '../../shared/issue-image/issue-image.component';
import { FaltaMaterialComponent } from '../../shared/falta-material/falta-material.component';
import { SignatureWidgetComponent } from '../../shared/signature-widget/signature-widget.component';
import { ContactDataComponent } from '../../shared/contact-data/contact-data.component';



@Component({
  selector: 'app-issue-mantenimiento',
  templateUrl: './issue-mantenimiento.component.html',
  styleUrls: ['./issue-mantenimiento.component.scss'],
})
export class IssueMantenimientoComponent implements OnInit, OnDestroy {

  @Input() issueFront: IssueFront;
  @Input() allCardsSelected: boolean;

  @Output() updateEvent = new EventEmitter();
  reparada = false;
  supplierUser: BaseUser = new BaseUser();
  checkboxModel = false;
  cardSelected = false;
  issueFrontSelection: IssueFrontSelection = null;

  private selectionAllCardsSubscription: Subscription;

  constructor(private portalProveedorService: PortalProveedorService,
              private issuePopulateService: IssuePopulateService,
              private modalCtrl: ModalController,
              private popOverCtrl: PopoverController,
              private messagesService: MessagesService,
              private uiService: UiService) { }

  ngOnDestroy(): void {
    if (this.selectionAllCardsSubscription) {
      this.selectionAllCardsSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.portalProveedorService.getSupplierData().subscribe((baseUser: BaseUser) => {
      this.supplierUser = baseUser;
    });
    this.issueFrontSelection = {
      selection: false,
      id: this.issueFront.id
    };
    this.checkboxModel = this.allCardsSelected;

  }

  selectCard() {
    if (this.checkboxModel) {
      this.issueFrontSelection.selection = true;
    } else {
      this.issueFrontSelection.selection = false;
    }
    this.portalProveedorService.selectionCardEvent.emit(this.issueFrontSelection);
  }

  async faltaMaterial() {
    const modal = await this.modalCtrl.create({
      component: FaltaMaterialComponent,
      componentProps: {
        isModal: true
      }
    });
    await modal.present();
    modal.onDidDismiss().then(resp => {
      if (resp.data) {
        const commentToSend = resp.data.commentToSend;
        const id = this.issueFront.id;
        // this.enviarComentario(commentToSend);
        this.enviarFaltaMaterial(commentToSend, id);
      }
    });
  }

  async addComentario(value: string) {
    const modal = await this.modalCtrl.create({
      component: AddComentarioModalComponent,
      componentProps: {
        isModal: true,
        comment: value
      }
    });
    await modal.present();
    modal.onDidDismiss().then(resp => {
      if (resp.data) {
        const commentToSend = resp.data.commentToSend;
        this.enviarComentario(commentToSend);
      }
    });
  }

  enviarFaltaMaterial(commentToSend: string, id: number) {
    const commentsToUpdate: SupplierCommentUpdateDataBase[] = [];
    const ids: number[] = [];
    ids.push(id);
    const supplierCommentUpdateDataBase: SupplierCommentUpdateDataBase = new SupplierCommentUpdateDataBase();
    supplierCommentUpdateDataBase.id = id;
    supplierCommentUpdateDataBase.add_comment_supplier = commentToSend;
    supplierCommentUpdateDataBase.add_comment_supplier_name = this.supplierUser.firstname + ' ' + this.supplierUser.lastname;
    commentsToUpdate.push(supplierCommentUpdateDataBase);
    this.portalProveedorService.doSupplierComment(commentsToUpdate).subscribe((commentsIds: number[]) => {
      this.portalProveedorService.marksAsPendingMaterial(ids).subscribe(resp => {
        const receivedId = resp['ids'][0];
        this.reloadIssueData(receivedId);
      });
    });
  }

  enviarComentario(commentToSend: string) {
    const commentsToUpdate: SupplierCommentUpdateDataBase[] = [];
    const supplierCommentUpdateDataBase: SupplierCommentUpdateDataBase = new SupplierCommentUpdateDataBase();
    supplierCommentUpdateDataBase.id = this.issueFront.id;
    supplierCommentUpdateDataBase.add_comment_supplier = commentToSend;
    supplierCommentUpdateDataBase.add_comment_supplier_name = this.supplierUser.firstname + ' ' + this.supplierUser.lastname;
    commentsToUpdate.push(supplierCommentUpdateDataBase);
    this.portalProveedorService.doSupplierComment(commentsToUpdate).subscribe((ids: number[]) => {
      ids.forEach(id => {
        this.reloadIssueData(id);
      });
    });
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  reparar() {
    const issuesIds = [];
    issuesIds.push(this.issueFront.id);
    this.portalProveedorService.markAsRepaired(issuesIds).subscribe((issueUpdateResponse: IssueUpdateResponse) => {
      issueUpdateResponse.ids.forEach(id => {
        this.reloadIssueData(id);
        this.reparada = true;
      });
    }, (error: QuproServiceError) => {
      console.log('error: ', error);
      this.reloadIssueData(this.issueFront.id, (issue: IssueFront) =>{
        if (issue.issueStateGroup.stateGroupKey === "repaired_closed") {
          const message = 'Id: ' + issue.id + ' actualizada con éxito.';
          this.showOkToast(message);
        } else {
          const message = 'id: ' + this.issueFront.id + ': ' + error.message;
          this.showErrorToast(message);
        }
      });
    });
  }

  updateIssue(issueToUpdate: IssueUpdateDataSupplier) {
    this.portalProveedorService.updateIssue(this.issueFront.id, issueToUpdate).subscribe(() => {
      this.reloadIssueData(this.issueFront.id);
      this.reparada = true;
    }, (error: QuproServiceError) => {
      const message = 'id: ' + this.issueFront.id + ': ' + error.message;
      this.showErrorToast(message);
    });
  }

  async conformOk() {
    const signedEvent: EventEmitter<ISignedData> = new EventEmitter();
    const modal = await this.modalCtrl.create({
      component: SignatureWidgetComponent,
      componentProps: {
        infoText: this.messagesService.getSupplierConformInfoText(this.issueFront.id),
        signed: signedEvent,
      }
    });
    signedEvent.subscribe((eventData: ISignedData) => {
      this.portalProveedorService.supplierAgreement(eventData.signatureName, eventData.signatureVat,
        [this.issueFront.id], eventData.base64, eventData.mimetype)
          .subscribe(
            (supplierAgreementUploaded: SupplierAgreementUploaded) => {
              this.uiService.logger.debug('[IssueCardComponent.conformOk] Done: ', supplierAgreementUploaded);
              this.reloadIssueData(this.issueFront.id);
            },
            (error: QuproServiceError) => {
              this.uiService.logger.error('[IssueCardComponent.conformOk] Error: ', error);
              if (error && error.type !== QuproServiceErrorType.UNATHORIZED && error.type !== QuproServiceErrorType.QUPRO_ERROR) {
                this.uiService.showSimpleMiddleToast(this.messagesService.getCanNotUpdateIssueError(), 5000);
              } else if (error && error.type === QuproServiceErrorType.QUPRO_ERROR) {
                this.uiService.showSimpleMiddleToast(error.message, 5000);
              }
          });
    });
    return await modal.present();
  }

  reloadIssueData(id: number, whenIssueUpdateCallback?:(issue: IssueFront)=> void) {
    const issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
    // issuesFilter.id = this.issueFront.id;
    issuesFilter.id = id;
    this.portalProveedorService.getMantenimientoIssuesFromCsiteSupplier(issuesFilter, null, 0, 0)
      .subscribe((resp: QuproList<IssueSupplier>) => {
        const updateIssue = this.issuePopulateService.convertirIssueSupplierToPostsaleFrontIssue(resp.elements[0]);
        if (whenIssueUpdateCallback) {
          whenIssueUpdateCallback(updateIssue);
        }else {
          const message = 'Id: ' + updateIssue.id + ' actualizada con éxito.';
          this.showOkToast(message);
        }
        this.updateEvent.emit(updateIssue);
      }, (error: QuproServiceError) => {
        const message = 'id: ' + this.issueFront.id + ': ' + error.message;
        this.showErrorToast(message);
      });
  }

  async openContactData(ev: any) {
    const popover = await this.popOverCtrl.create({
      component: ContactDataComponent,
      event: ev,
      componentProps: {
        firstName: this.issueFront.contact_firstname,
        lastName: this.issueFront.contact_lastname,
        phone: this.issueFront.contact_phone,
        email: this.issueFront.contact_email
      }
    });
    return await popover.present();
  }

  async openIssueImage(ev: Event) {
    const modalCtrl = await this.modalCtrl.create({
      component: IssueImageComponent,
      componentProps: {
        issueFront: this.issueFront,
        isModal: true
      }

    });
    return await modalCtrl.present();
  }

  private showOkToast(message: string) {
    this.uiService.showSimpleBottomToast(message, 2000);
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

}
